export const SET_USER_PROFILE = 'features/Profile/SET_USER_PROFILE' as string;
export const FETCH_USER_PROFILE = 'features/Profile/FETCH_USER_PROFILE' as string;
